import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export const cartIconStyles = () => {
    return css`
        padding: 5px 10px;
        > ${TypographyStyle} {
            width: 0px;
        }
        > ${IconWrapper} {
            margin-left: 0px;
            height: 22px;
            width: 22px;

            > svg {
                height: 22px;
                width: 22px;
            }
        }
    `
};
